import { render, staticRenderFns } from "./MLoaderFrame.vue?vue&type=template&id=047c2dfe&"
import script from "./MLoaderFrame.ts?vue&type=script&lang=ts&"
export * from "./MLoaderFrame.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports